
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/branduri",
      function () {
        return require("private-next-pages/branduri.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/branduri"])
      });
    }
  